var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstaicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4147 32.9813C45.4147 32.2103 46.0397 31.5853 46.8107 31.5853C47.5816 31.5853 48.2066 32.2103 48.2066 32.9813C48.2066 33.7522 47.5816 34.3772 46.8107 34.3772C46.0397 34.3772 45.4147 33.7522 45.4147 32.9813Z",
    fill: "#1DF66A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.831 33.3303C36.1689 33.3303 33.2002 36.2989 33.2002 39.961C33.2002 43.623 36.1689 46.5917 39.831 46.5917C43.493 46.5917 46.4617 43.623 46.4617 39.961C46.4617 36.2989 43.493 33.3303 39.831 33.3303ZM35.2942 39.961C35.2942 37.4554 37.3254 35.4242 39.831 35.4242C42.3366 35.4242 44.3678 37.4554 44.3678 39.961C44.3678 42.4666 42.3366 44.4978 39.831 44.4978C37.3254 44.4978 35.2942 42.4666 35.2942 39.961Z",
    fill: "#1DF66A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1712 27.1644C42.332 26.6236 37.3299 26.6236 32.4908 27.1644C29.6821 27.4783 27.4146 29.6909 27.0844 32.5142C26.5057 37.4619 26.5057 42.4601 27.0844 47.4077C27.4146 50.231 29.6821 52.4436 32.4908 52.7575C37.3299 53.2984 42.332 53.2984 47.1712 52.7575C49.9799 52.4436 52.2473 50.231 52.5776 47.4077C53.1562 42.4601 53.1562 37.4619 52.5776 32.5142C52.2473 29.6909 49.9799 27.4783 47.1712 27.1644ZM32.7234 29.2454C37.4079 28.7218 42.254 28.7218 46.9386 29.2454C48.7953 29.4529 50.2827 30.9181 50.4978 32.7575C51.0576 37.5435 51.0576 42.3785 50.4978 47.1645C50.2827 49.0039 48.7953 50.4691 46.9386 50.6766C42.254 51.2001 37.4079 51.2001 32.7234 50.6766C30.8666 50.4691 29.3793 49.0039 29.1641 47.1645C28.6044 42.3785 28.6044 37.5435 29.1641 32.7575C29.3793 30.9181 30.8666 29.4529 32.7234 29.2454Z",
    fill: "#1DF66A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0688 40.0291L25.1118 15.706L53.1978 15.706L67.2407 40.0291L53.1978 64.3522L25.1118 64.3522L11.0688 40.0291Z",
    fill: "#1DF66A",
    fillOpacity: 0.12,
    stroke: "url(#paint0_linear_541_424)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_541_424",
    x1: 24.8231,
    y1: 15.206,
    x2: 60.1834,
    y2: 77.5302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DF66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#FCFCFC",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D968F",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaicon);
export default __webpack_public_path__ + "static/media/instaicon.9c1d1b9d1d5c621ee29f319979bf2257.svg";
export { ForwardRef as ReactComponent };